import { EditorState } from '../types';

/**
 * 트랙의 items 배열에 존재하지만 items 맵에 없는 orphan 참조를 제거합니다.
 *
 * 삭제/분할/undo-redo 등의 작업에서 items 맵과 tracks의 참조가
 * 불일치하는 경우를 방어적으로 정리합니다.
 */
export const sanitizeOrphanedTrackItems = (state: EditorState): EditorState => {
  const { items, tracks } = state.undoableState;

  let hasOrphans = false;

  // 빠른 체크: orphan이 있는지 먼저 확인
  for (const track of tracks) {
    for (const itemId of track.items) {
      if (!items[itemId]) {
        hasOrphans = true;
        break;
      }
    }
    if (hasOrphans) break;
  }

  if (!hasOrphans) {
    return state;
  }

  // orphan이 발견된 경우에만 새 상태 생성
  const orphanIds: string[] = [];
  const newTracks = tracks.map((track) => {
    const cleanedItems = track.items.filter((itemId) => {
      if (!items[itemId]) {
        orphanIds.push(itemId);
        return false;
      }
      return true;
    });

    if (cleanedItems.length === track.items.length) {
      return track;
    }

    return { ...track, items: cleanedItems };
  });

  console.warn(
    `[sanitizeOrphanedTrackItems] ${orphanIds.length}개의 orphan 아이템 참조 제거:`,
    orphanIds,
  );

  return {
    ...state,
    undoableState: {
      ...state.undoableState,
      tracks: newTracks,
    },
  };
};
